import React from "react";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import BarChartWrapper from "./BarChartWrapper";
import { Box, Typography } from "@material-ui/core";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BarChartTab({ data }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dataBarChart = data.filter((d) => d.data.length > 0);

  return (
    <>
      <AppBar position="static" color="default" style={{ zIndex: 0 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          {data.map((tab, i) => {
            if (tab.data.length !== 0) {
              return (
                <Tab
                  key={i}
                  label={<Typography>{tab.data[0].title}</Typography>}
                  {...a11yProps(i)}
                ></Tab>
              );
            }
          })}
        </Tabs>
      </AppBar>
      {dataBarChart.map((tab, i) => {
        if (tab?.data?.length >= 1) {
          if (i === value) {
            return <BarChartWrapper key={i} data={tab.data} />;
          }
        }
      })}
    </>
  );
}
